
const styles = (theme) => ({
  ...theme.global,
  box: {
    ...theme.flexColumnCenter
  },
})
export default styles
